
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MaintenanceDetail from "./maintenance-detail.vue";
import t from "@common/src/i18n/t";

const guidance = namespace("guidance");

@Component({ components: { MaintenanceDetail } })
export default class ComMaintenanceMileage extends Vue {
  @Prop({ default: () => ({}), type: Object }) modelData: any;
  @guidance.Action queryMaintenanceItemDetail;
  @guidance.Mutation setMaintenanceItemDetailLoading;
  @Prop({ default: "", type: String }) modelCode: string;
  @Prop({ default: "mileage", type: String }) queryType: string;
  showDetail = false;
  get dataList() {
    return (this.modelData?.itemList || []).map(item => {
      return {
        maintenanceName: item.maintenanceName,
        maintenanceId: item.maintenanceId,
        ...item.valueMap
      };
    });
  }
  get tableColumnArr() {
    return (this.modelData?.title || []).map(item => {
      return {
        name: `${item}${this.queryType === "mileage" ? t("v218_0.kilometre") : t("v213.special-month")}`,
        value: item,
        id: `C${item}`
      };
    });
  }
  itemDetailData: any = {};
  handleShowItemDetail(maintenanceId) {
    this.showDetail = true;
    this.setMaintenanceItemDetailLoading(true);
    this.queryMaintenanceItemDetail({
      modelCode: this.modelCode,
      maintenanceId: maintenanceId
    })
      .then(data => {
        this.itemDetailData = data.data;
      })
      .finally(() => {
        this.setMaintenanceItemDetailLoading(false);
      });
  }
}
